import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllRegenerationUserSuccess,
  getAllRegenerationUserFailed,
  GET_ALL_REGENERATION_USER_START,
} from '../../actions/regeneration'

/**
 * get list regeneration user
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListRegenerationUserApi = (props) => {
  var uri = `/users/regeneration`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListRegenerationUser(action) {
  try {
    const response = yield call(getListRegenerationUserApi, action?.payload)
    yield put(getAllRegenerationUserSuccess(response?.data))

    // Call callback action if provided
    if (action.onSuccess) {

      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllRegenerationUserFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list genesis user
 */
export default function* watchGetListRegenerationUser() {
  yield takeLatest(GET_ALL_REGENERATION_USER_START, doGetListRegenerationUser)
}
